import React from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { UserOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Avatar } from 'antd';

import { logout } from 'redux/user/actions';

import styles from './style.module.scss';

const mapStateToProps = ({ user }) => ({ user });

const ProfileMenu = ({ dispatch, user }) => {
  const intl = useIntl();

  const handleLogout = e => {
    e.preventDefault();
    dispatch(logout());
  };

  const menu = (
    <Menu selectable={false}>
      <Menu.Item>
        <strong>
          {intl.formatMessage({ id: 'topBar.profileMenu.hello' })}, {user.name || 'Anonymous'}
        </strong>
        <div>
          <strong>{intl.formatMessage({ id: 'topBar.profileMenu.role' })}: </strong>
          {user.role || '—'}
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <div>
          <strong>{intl.formatMessage({ id: 'topBar.profileMenu.email' })}: </strong>
          {user.email || '—'}
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <a href='#' onClick={handleLogout}>
          <i className='fe fe-log-out mr-2' />
          {intl.formatMessage({ id: 'topBar.profileMenu.logout' })}
        </a>
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <div className={styles.dropdown}>
        <Avatar className={styles.avatar} shape='square' size='large' icon={<UserOutlined />} />
      </div>
    </Dropdown>
  );
};

export default connect(mapStateToProps)(ProfileMenu);
